/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Platform, StyleSheet, View, type ViewStyle } from 'react-native';
import { ticketColors } from '../../shared/theme/ticketColors';
import { BrandWatermark } from './BrandWatermark';

type AuthScreenFrameProps = {
  children: React.ReactNode;
  showWatermark?: boolean;
  /** Fondo del frame (default: ticket). En login split desktop usar blanco. */
  backgroundColor?: string;
};

/**
 * Contenedor no-auth: fondo ticket + V transparente (`vuelto-v-mark.png`) + contenido centrado.
 * El scroll hijo debe ser transparente (`variant="auth"` / `transparentBackground`) para no tapar la V.
 */
export function AuthScreenFrame({
  children,
  showWatermark = true,
  backgroundColor,
}: AuthScreenFrameProps) {
  return (
    <View style={[styles.root, backgroundColor ? { backgroundColor } : null]}>
      {showWatermark ? <BrandWatermark variant="auth" /> : null}
      <View style={[styles.content, Platform.OS === 'web' ? styles.contentWeb : null]} pointerEvents="box-none">
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    overflow: 'hidden',
  } as ViewStyle,
  content: {
    flex: 1,
  } as ViewStyle,
  contentWeb: {
    position: 'relative',
    zIndex: 1,
  } as ViewStyle,
});
